<template>
  <v-container fluid fill-height grid-list-xs pa-0>
    <v-layout row wrap align-stretch>
      <v-form v-model="valid" style="width: 100%;">
        <v-layout row wrap justify-center>
          <v-flex xs12 sm5 md2 lg3>
            <v-text-field
              placeholder="Identificação do cliente"
              class="pr-3"
              v-model="opcoes.id_pessoa"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm5 md3 lg3>
            <v-text-field
              placeholder="CPF do Cliente"
              mask="###.###.###-##"
              class="pr-3"
              v-model="opcoes.cpf"
              :rules="[rules.cpf]"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm5 md4 lg4>
            <v-select
              label="Frentista"
              item-value="id_frentista"
              v-model="opcoes.id_frentista"
              :items="frentistas"
              clearable
            >
            <template v-slot:item="data">
                <v-avatar
                  color="grey"
                  size="30">
                  <img v-if="data.item.url_imagem_perfil || (data.item.pessoa && data.item.pessoa.url_imagem_perfil)" :src="data.item.url_imagem_perfil || data.item.pessoa.url_imagem_perfil" alt="trevor">
                  <v-icon dark v-else>face</v-icon>
                </v-avatar>
                <v-spacer></v-spacer>
                <span v-text="`${data.item.nome ? (data.item.nome + ' ' + data.item.sobrenome) : (data.item.pessoa.nome + ' ' + data.item.pessoa.sobrenome)}`"></span>
                <v-spacer></v-spacer>
              </template>
              <template v-slot:selection="data">
                <v-avatar
                  color="grey"
                  size="30">
                  <img v-if="data.item.url_imagem_perfil || (data.item.pessoa && data.item.pessoa.url_imagem_perfil)" :src="data.item.url_imagem_perfil || data.item.pessoa.url_imagem_perfil" alt="trevor">
                  <v-icon dark v-else>face</v-icon>
                </v-avatar>
                <v-spacer></v-spacer>
                <span v-text="`${data.item.nome ? (data.item.nome + ' ' + data.item.sobrenome) : (data.item.pessoa.nome + ' ' + data.item.pessoa.sobrenome)}`"></span>
                <v-spacer></v-spacer>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs12 sm5 md4 lg4>
            <v-select
              :items="options"
              item-text="title"
              item-value="value"
              v-model="selectOpcoes"
            >
            </v-select>
          </v-flex>
          <v-flex xs12 sm5 md4 lg4>
            <v-menu
              ref="menuDataInicial"
              v-model="menuDataInicial"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-if="opcoes.custom"
                  v-model="opcoes.intervalo_relatorio"
                  label="Dias"
                  multiple
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  prepend-icon="event"
                  required
                  v-on="on"
                  clearable
                ></v-combobox>
                <v-combobox
                  v-else-if="opcoes.dia"
                  v-model="opcoes.data_relatorio"
                  label="Dia"
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  @blur="date = parseDate(opcoes.data_relatorio)"
                  prepend-icon="event"
                  required
                  v-on="on"
                  clearable
                ></v-combobox>
                <v-combobox
                  v-else
                  v-model="opcoes.mes_relatorio"
                  label="Mes"
                  persistent-hint
                  chips
                  small-chips
                  readonly
                  flat
                  @blur="month = parseDate(opcoes.mes_relatorio)"
                  prepend-icon="event"
                  required
                  v-on="on"
                  clearable
                ></v-combobox>
              </template>
              <v-date-picker v-show="opcoes.custom" multiple v-model="dates" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
              <v-date-picker v-show="opcoes.dia" v-model="date" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
              <v-date-picker v-show="opcoes.mes" v-model="month" type="month" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
            </v-menu>
          </v-flex>
           <v-flex shrink>
             <v-btn icon color="info" @click="carregarRelatorio(true)"><v-icon>search</v-icon></v-btn>
           </v-flex>
          <v-flex shrink>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-tile
                  @click="editando = !editando"
                >
                  <v-list-tile-action>
                    <v-icon v-if="!editando">edit</v-icon>
                    <v-icon v-else>done</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Editar relatório</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  @click="print()"
                >
                  <v-list-tile-action>
                    <v-icon>print</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>Imprimir relatório</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-form>
      <v-flex xs12 class="print">
        <div class="pb-3 pt-5 hide-display">
          <v-layout row>
            <h1> Relatório de compras</h1>
            <v-spacer></v-spacer>
            <span class="display-2">Total: {{ total_relatorio_compras | currency({ fractionCount: 2 }) }}</span>
          </v-layout>
          <hr/>
        </div>
        <v-data-table
          hide-actions
          :hide-headers="!compras || !compras.length"
          :loading="loading"
          :items="compras"
          :pagination.sync="pagination"
          :total-items="totalItens"
          class="elevation-1"
        >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left px-3" v-if="headersVisible.avatar">
                <v-icon color="success">attach_money</v-icon>
              </td>
              <td class="text-xs-left" v-if="headersVisible.cliente">
                <template v-if="props.item.cliente">
                  {{`${props.item.cliente.nome_completo}` | truncate(30) }}
                  <div>ID: <strong>{{props.item.cliente.id_pessoa}}</strong></div>
                </template>
              </td>
              <td class="text-xs-left px-3" v-if="headersVisible.data_compra">
                {{ props.item.data_compra.split('-').reverse().join('/') }}
              </td>
              <td class="text-xs-left pl-2 pr-4"  v-if="headersVisible.acrescimo">
                {{ calcularAcrescimo(props.item.valor, props.item.valor_total) }}%
              </td>
              <td class="text-xs-left pl-2 pr-4"  v-if="headersVisible.tipo_pagamento">
                {{ props.item.tipo_pagamento }}
              </td>
              <td class="text-xs-right pl-2 pr-4"   v-if="headersVisible.valor">
                <strong>{{ props.item.valor | currency({ fractionCount: 2 }) }}</strong>
              </td>
              <td class="text-xs-center px-0"  v-if="headersVisible.confirmada">
                <v-tooltip v-if="props.item.confirmado" top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="teal">done_all</v-icon>
                    </template>
                    <span>Confirmada</span>
                </v-tooltip>
                <v-tooltip v-else top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="red">close</v-icon>
                    </template>
                    <span>Pagamento não efetuado</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:headers>
            <tr>
              <th class="text-xs-center px-4" v-if="headersVisible.avatar">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.avatar = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
              <th class="text-xs-left" v-if="headersVisible.cliente">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.cliente = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Cliente
              </th>
              <th class="text-xs-left  px-3" v-if="headersVisible.data_compra">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data_compra = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Data
              </th>
              <th class="text-xs-left" v-if="headersVisible.acrescimo">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.acrescimo = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Acréscimo
              </th>
              <th class="text-xs-left px-4" v-if="headersVisible.tipo_pagamento">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.tipo_pagamento = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Tipo de Pagamento
              </th>
              <th class="text-xs-right pl-2 pr-4" v-if="headersVisible.valor">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.valor = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Valor (R$)
              </th>
              <th class="text-xs-center px-4" v-if="headersVisible.confirmada">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.confirmada = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center">
          <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-footer
      absolute
      dense
      style="background: transparent"
    >
      <v-expand-transition>
        <v-toolbar dense v-show="compras.length">
          <v-toolbar-title>
            Valor com Acréscimo: {{ total_valor_compras | currency({ fractionCount: 2 }) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>
            Valor Real: {{ valor_compras | currency({ fractionCount: 2 }) }}
          </v-toolbar-title>
        </v-toolbar>
      </v-expand-transition>
    </v-footer>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      valor_compras: 0,
      total_valor_compras: 0,
      valid: false,
      editando: false,
      menuDataInicial: false,
      date: moment().format(`YYYY-MM-DD`),
      month: new Date().toISOString().substr(0, 10),
      dates: [],
      total_relatorio_compras: 0,
      headersVisible: {
        data_compra: true,
        confirmada: true,
        cliente: true,
        valor: true,
        avatar: true,
        frentista: true,
        acrescimo: true,
        tipo_pagamento: true
      },
      rules: {
        cpf: value => {
          return (value && value.length === 11) || 'CPF inválido.'
        }
      },
      today: null,
      selectOpcoes: 'dia',
      options: [
        {
          title: 'Dia',
          value: 'dia'
        },
        {
          title: 'Mês',
          value: 'mes'
        },
        {
          title: 'Intervalo',
          value: 'custom'
        }
      ],
      opcoes: {
        dia: true,
        custom: false,
        mes: false,
        data_relatorio: moment().format(`DD/MM/YYYY`),
        mes_relatorio: null,
        intervalo_relatorio: [],
        id_pessoa: undefined,
        cpf: undefined,
        id_frentista: undefined
      },
      compras: [],
      totalItens: 0,
      pagination: {
        page: 1,
        rowsPerPage: 10
      }
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    },
    frentistas () {
      return this.$store.getters.frentistas
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItens == null
      ) return 0

      const pages = Math.ceil(this.totalItens / this.pagination.rowsPerPage)
      return pages
    }
  },
  watch: {
    pagination: {
      handler (val) {
        if (this.posto) this.carregarRelatorio(false)
      },
      deep: true
    },
    date (val) {
      if (val) {
        this.opcoes.data_relatorio = this.formatDate(this.date)
      }
    },
    month (val) {
      if (val) {
        this.opcoes.mes_relatorio = this.formatDate(this.month)
      }
    },
    selectOpcoes (val) {
      this.limparOpcoes()
      if (val === 'dia') {
        this.opcoes.dia = true
        this.opcoes.data_relatorio = this.formatDate(this.date)
      } else if (val === 'custom') {
        this.opcoes.custom = true
        this.opcoes.data_relatorio = this.formatDate(this.date)
      } else if (val === 'mes') {
        this.opcoes.mes = true
        this.opcoes.mes_relatorio = this.formatDate(this.month)
      }
    },
    posto (val) {
      if (val) {
        this.$store.dispatch('listarFrentistas')
        this.carregarRelatorio(true)
      }
    }
  },
  mounted () {
    this.today = new Date().setHours(0, 0, 0, 0)
    if (this.posto) {
      this.carregarRelatorio(true)
    }
  },
  methods: {
    print () {
      window.print()
    },
    formatDate (date) {
      if (!date) return null

      if (this.opcoes.dia || this.opcoes.custom) {
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      } else {
        const [year, month] = date.split('-')
        return `${month}/${year}`
      }
    },
    orderDates () {
      this.dates.sort((a, b) => {
        a = new Date(a.split('-'))
        b = new Date(b.split('-'))
        return a < b ? -1 : a > b ? 1 : 0
      })
    },
    parseDate (date) {
      if (!date) return null

      if (this.opcoes.dia || this.opcoes.custom) {
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } else {
        const [month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}`
      }
    },
    limparOpcoes () {
      this.opcoes.dia = false
      this.opcoes.custom = false
      this.opcoes.mes = false
    },
    carregarRelatorio (zerarPaginacao) {
      const data = {
        page: zerarPaginacao ? 1 : this.pagination.page,
        page_size: this.pagination.rowsPerPage,
        posto: this.posto.cnpj
      }
      if (this.opcoes.id_pessoa) data.cliente__pessoa__id_pessoa = this.opcoes.id_pessoa
      if (this.opcoes.cpf) data.cliente__pessoa__cpf = this.opcoes.cpf
      if (this.opcoes.id_frentista) data.frentista__id_frentista = this.opcoes.id_frentista
      if (this.opcoes.custom && this.opcoes.intervalo_relatorio && this.opcoes.intervalo_relatorio.length === 2) {
        data.data_compra__gte = this.opcoes.intervalo_relatorio[0]
        data.data_compra__lte = this.opcoes.intervalo_relatorio[1]
      } else if (this.opcoes.dia && this.date) {
        data.data_compra = this.date.split('-').reverse().join('/')
      } else if (this.opcoes.mes && this.month && this.month.length) {
        data['data_compra__month'] = this.month.split('-')[1]
        data['data_compra__year'] = this.month.split('-')[0]
      }

      this.$store.dispatch('pegarComprasCashPosto', data).then(json => {
        this.compras = json.results.compras
        this.totalItens = json.count
        this.valor_compras = json.results.valor
        this.total_valor_compras = json.results.valor_total
      })
    },
    dataSelecionada () {
      if (this.opcoes.custom) {
        if (this.dates.length === 3) {
          let day1 = this.dates[0]
          let day2 = this.dates[2]
          this.dates = []
          this.dates = [day1, day2]
        }
        if (this.dates.length) {
          this.orderDates()
        }
        this.opcoes.intervalo_relatorio = this.dates.map(this.formatDate)
      } else {
        this.menuDataInicial = false
      }
    },
    calcularAcrescimo (valor, valorTotal) {
      if (!valor) return 0
      if (!valorTotal) return 0
      return ((valorTotal - valor) * 100 / valor).toFixed(0)
    }
  }
}
</script>
